import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { AccountPage } from '../../../features/account/ui/account-overview/AccountPage';
import { IAccountPageData } from '../../../features/account/domain/pages/IAccountPageData';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IAccountPageData> =
	createGetStaticPropsWithPage(PassengersPageId.AccountOverview);

export default AccountPage;
